import React, { useState } from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import LoadMask from '../../../../components/LoadMask';
import Popup from '../../../../components/Popup';
import ENDPOINT from '../../../../constants/endpoints';
import UxHelpers from '../../../../helpers/ux-helpers';
import useApi from '../../../../hooks/useApi';
import Dialog from '../../index';

const RecruiterSubscriptionRequestDialog = props => {
  const { initialText = '', show, proceed, dismiss } = props;

  const api = useApi();

  const [text, setText] = useState(
    initialText || 'Would you like to send request to learn more?'
  );
  const [completed, setCompleted] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const dismissHandler = () => {
    dismiss();
    UxHelpers.overflowLock('unlock');
  };

  const onSuccess = data => {
    proceed(data);
    UxHelpers.overflowLock('unlock');
  };

  const sendRequest = () => {
    setIsSending(true);
    UxHelpers.overflowLock('unlock');
    api.post(
      ENDPOINT.ACTION.RECRUITER_SUBSCRIPTION_REQUEST,
      {},
      {
        handleComplete: ({ data: { message = 'ERROR' } }) => {
          setText(message);
          setCompleted(true);
          setIsSending(false);
        },
      }
    );
  };

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={completed ? onSuccess : sendRequest}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Ok"
      />
      {!completed && (
        <BasicButton
          controlFunc={dismissHandler}
          btnWidth={200}
          btnHeight={40}
          btnFontWeight={500}
          btnArrow={false}
          btnTextColor="#27282d"
          btnText="No Thanks"
        />
      )}
    </BasicButtonGroup>
  );

  const body = (
    <Dialog dialogStyles={{ textAlign: 'center' }}>
      <div style={{ whiteSpace: 'pre-wrap' }}>{text}</div>
    </Dialog>
  );

  return (
    show &&
    (isSending ? (
      <LoadMask />
    ) : (
      <Popup
        actions={{
          dismiss,
        }}
        buttonsRender={buttons}
        bodyRender={body}
      />
    ))
  );
};

export default createConfirmation(
  confirmable(RecruiterSubscriptionRequestDialog)
);
